var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspection12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22614",
    "data-name": "Group 22614",
    transform: "translate(8915 -5398)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(-8915 5398)",
    fill: "#fec400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16310",
    "data-name": "Path 16310",
    d: "M1.86-.712,2.06,0h.48V-3.008H.036v.64H1.86a1.942,1.942,0,0,1-.1.732,1.666,1.666,0,0,1-.356.592,1.661,1.661,0,0,1-.58.4A2.037,2.037,0,0,1,.028-.5,1.814,1.814,0,0,1-.816-.692a1.843,1.843,0,0,1-.612-.5A2.246,2.246,0,0,1-1.8-1.924a2.882,2.882,0,0,1-.128-.86,3.571,3.571,0,0,1,.112-.892,2.391,2.391,0,0,1,.348-.776A1.8,1.8,0,0,1-.864-5a1.8,1.8,0,0,1,.892-.208,2.328,2.328,0,0,1,.6.076A1.662,1.662,0,0,1,1.14-4.9a1.339,1.339,0,0,1,.376.388,1.5,1.5,0,0,1,.208.564h.76a2.309,2.309,0,0,0-.3-.86A2.018,2.018,0,0,0,1.64-5.4,2.217,2.217,0,0,0,.9-5.74a3.443,3.443,0,0,0-.876-.108A2.643,2.643,0,0,0-1.16-5.6a2.488,2.488,0,0,0-.848.676,2.924,2.924,0,0,0-.512.988,4.05,4.05,0,0,0-.172,1.188,3.214,3.214,0,0,0,.184,1.08,2.783,2.783,0,0,0,.536.92,2.585,2.585,0,0,0,.856.636A2.667,2.667,0,0,0,.028.128a2.7,2.7,0,0,0,1-.2A1.9,1.9,0,0,0,1.86-.712Z",
    transform: "translate(-8909 5407)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection12);
export default __webpack_public_path__ + "static/media/inspection_12.4414585b0af52e9a511e045a5748f82e.svg";
export { ForwardRef as ReactComponent };